module.exports = __webpack_public_path__ + "img/IMG_4215_L_Foamcore.54eb260b.jpg";